import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const BAR_STYLE = "flex-1 h-1"
const TEXT_STYLE = "flex items-center justify-center size-12 rounded-full text-base font-medium"

interface ReportCreationHeaderPanelProps {
    reportState: "details" | "type" | "documents" | "additional" | "additional_details" | "summary" | "done"
}
export function ReportCreationHeaderPanel({ reportState }: Readonly<ReportCreationHeaderPanelProps>) {
    const detailsBarStyle = () => {
        return reportState === "details" ? "bg-gray-200" : "bg-green-500"
    }

    const detailsTextStyle = () => {
        return reportState === "details" ? "bg-blue-500 text-white" : "bg-green-500 text-white"
    }

    const typeBarStyle = () => {
        return (reportState === "documents" || reportState === "additional" || reportState === "additional_details" || reportState === "summary" || reportState === "done") ? "bg-green-500" : "bg-gray-200"
    }

    const typeTextStyle = () => {
        return reportState === "type" ? "bg-blue-500 text-white" : (reportState === "details" ? "bg-gray-200 text-gray-600" : "bg-green-500 text-white")
    }

    const projectBarStyle = () => {
        return (reportState === "additional" || reportState === "additional_details" || reportState === "summary" || reportState === "done") ? "bg-green-500" : "bg-gray-200"
    }

    const projectTextStyle = () => {
        return (reportState === "documents") ? "bg-blue-500 text-white" : ((reportState === "additional" || reportState === "additional_details" || reportState === "summary" || reportState === "done") ? "bg-green-500 text-white" : "bg-gray-200 text-gray-600")
    }

    const documentsBarStyle = () => {
        return (reportState === "additional_details" || reportState === "summary" || reportState === "done") ? "bg-green-500" : "bg-gray-200"
    }

    const documentsTextStyle = () => {
        return (reportState === "additional") ? "bg-blue-500 text-white" : (reportState === "additional_details" || reportState === "summary" || reportState === "done" ? "bg-green-500 text-white" : "bg-gray-200 text-gray-600")
    }

    const additionalTextStyle = () => {
        return (reportState === "additional_details") ? "bg-blue-500 text-white" : (reportState === "summary" || reportState === "done" ? "bg-green-500 text-white" : "bg-gray-200 text-gray-600")
    }

    return (
        <>
            <div className="flex items-center justify-between gap-0 w-full">
                <div className="flex flex-1 items-center gap-2 justify-center">
                    <div className={"flex-1"} />
                    <div className={cn(TEXT_STYLE, detailsTextStyle())}>
                        {reportState === "details" ? "1" : <Check />}
                    </div>
                    <div className={cn(BAR_STYLE, detailsBarStyle())} />
                </div>
                <div className="flex flex-1 items-center gap-2 justify-center">
                    <div className={cn(BAR_STYLE, detailsBarStyle())} />
                    <div className={cn(TEXT_STYLE, typeTextStyle())}>
                        {(reportState === "details" || reportState === "type") ? "2" : <Check />}
                    </div>
                    <div className={cn(BAR_STYLE, typeBarStyle())} />
                </div>
                <div className="flex flex-1 items-center gap-2 justify-center">
                    <div className={cn(BAR_STYLE, typeBarStyle())} />
                    <div className={cn(TEXT_STYLE, projectTextStyle())}>
                        {(reportState === "details" || reportState === "type" || reportState === "documents") ? "3" : <Check />}
                    </div>
                    <div className={cn(BAR_STYLE, projectBarStyle())} />
                </div>
                <div className="flex flex-1 items-center gap-2 justify-center">
                    <div className={cn(BAR_STYLE, projectBarStyle())} />
                    <div className={cn(TEXT_STYLE, documentsTextStyle())}>
                        {reportState !== "additional_details" && reportState !== "summary" && reportState !== "done" ? "4" : <Check />}
                    </div>
                    <div className={cn(BAR_STYLE, documentsBarStyle())} />
                </div>
                <div className="flex flex-1 items-center gap-2 justify-center">
                    <div className={cn(BAR_STYLE, documentsBarStyle())} />
                    <div className={cn(TEXT_STYLE, additionalTextStyle())}>
                        {reportState !== "summary" && reportState !== "done" ? "5" : <Check />}
                    </div>
                    <div className={"flex-1"} />
                </div>
            </div>
            <div className="flex justify-between text-sm w-full">
                <div className="flex-1 text-center">
                    <div className="font-medium">
                        Report Details
                    </div>
                    <div className="text-gray-500 text-xs">
                        Name and Description
                    </div>
                </div>
                <div className="flex-1 text-center">
                    <div className="font-medium">
                        Report Type
                    </div>
                    <div className="text-gray-500 text-xs">
                        Type and Template
                    </div>
                </div>
                <div className="flex-1 text-center">
                    <div className="font-medium">
                        Select Documents
                    </div>
                    <div className="text-gray-500 text-xs">
                        Choose content
                    </div>
                </div>
                <div className="flex-1 text-center">
                    <div className="font-medium">
                        Additional Documents
                    </div>
                    <div className="text-gray-500 text-xs">
                        (Optional)
                    </div>
                </div>
                <div className="flex-1 text-center">
                    <div className="font-medium">
                        Template Details
                    </div>
                    <div className="text-gray-500 text-xs">
                        Additional information
                    </div>
                </div>
            </div>
        </>
    )
}